import Tag from 'antd/es/tag';
import Typography from 'antd/es/typography';
import React from 'react';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from './TaskLayout';

const { Text } = Typography;

const MobileMetadataRow = styled.div`
  display: none;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 16px;
  }
`;

const MetadataItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const SidebarLabel = styled(Text)`
  display: block;
  margin-bottom: 8px;
`;

interface TaskMobileMetadataProps {
  status?: string | null | undefined;
}

const TaskMobileMetadata: React.FC<TaskMobileMetadataProps> = ({ status }) => {
  return (
    <MobileMetadataRow>
      <MetadataItem>
        <SidebarLabel type="secondary">Status</SidebarLabel>
        <Tag
          color={
            status === 'in_progress'
              ? 'processing'
              : status === 'completed'
                ? 'success'
                : status === 'failed'
                  ? 'error'
                  : 'default'
          }
        >
          {status === 'in_progress'
            ? 'In Progress'
            : status === 'completed'
              ? 'Completed'
              : status === 'failed'
                ? 'Failed'
                : status}
        </Tag>
      </MetadataItem>
    </MobileMetadataRow>
  );
};

export default TaskMobileMetadata;
